module.exports = __webpack_public_path__ + "static/img/award1_a.e3fe1b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award1_a.png
// module id = 8Rb3
// module chunks = 7